export const COMPANIES_KEY = 'companies';

export const companiesKey = {
  all: [COMPANIES_KEY],
  lists: token => [...companiesKey.all, 'list', token],
  detail: (token, companyId) => [
    ...companiesKey.all,
    'detail',
    token,
    companyId
  ],
  search: (token, param, start, includePulseData) => [
    ...companiesKey.all,
    'search',
    token,
    param,
    start,
    includePulseData
  ]
};
